/* ============================================================
   FREQUENTLY BOUGHT TOGETHER JS — Karar Store
   Fixed: paisa->rupees conversion, title dedup, dynamic price
   ============================================================ */

(function () {
  'use strict';

  var FBT_RULES = [
    {
      productHandle: 'pu-leather-wallet-for-men-pop-up-card-holder',
      recommended: [
        {
          title: 'Karar Flux Sling Bag',
          handle: 'karar-flux-modern-leather-crossbody-sling-bag',
          price: 1999,
          image: 'https://cdn.shopify.com/s/files/1/0626/1912/3870/files/ChatGPT_Image_Sep_30_2025_03_08_01_AM.png',
          url: '/products/karar-flux-modern-leather-crossbody-sling-bag'
        }
      ],
      discountCode: 'BUNDLE10',
      discountPct: 10
    }
  ];

  function getCurrentHandle() {
    var match = window.location.pathname.match(/\/products\/([^/?]+)/);
    return match ? match[1] : null;
  }

  function fmt(rupees) {
    return 'Rs. ' + Math.round(rupees).toLocaleString();
  }

  // Always returns price in RUPEES (not paisa)
  function getCurrentVariantPrice() {
    // Try meta first (most reliable)
    if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
      var variants = window.ShopifyAnalytics.meta.product.variants;
      if (variants && variants.length) {
        var selectedInput = document.querySelector('input[name="id"]:checked, select[name="id"]');
        var selectedId = selectedInput ? parseInt(selectedInput.value) : null;
        var variant = selectedId ? variants.find(function(v) { return v.id === selectedId; }) : variants[0];
        if (variant && variant.price) return variant.price / 100;
      }
    }
    // Fallback: read from DOM price element — strip non-numeric, already in rupees
    var priceEl = document.querySelector('.price .price-item--regular, .price__regular .price-item');
    if (priceEl) {
      var text = priceEl.textContent.replace(/[^0-9.]/g, '');
      var val = parseFloat(text);
      // If value looks like paisa (>10000 for a wallet), divide by 100
      if (val > 10000) val = val / 100;
      if (val) return val;
    }
    return 1999;
  }

  function calcPrices(price1, rec, discountPct) {
    var original = price1 + rec.price;
    var discounted = Math.round(original * (1 - discountPct / 100));
    var saving = original - discounted;
    return { original: original, discounted: discounted, saving: saving };
  }

  function updateFBTPrices(fbt, rec, discountPct) {
    var price1 = getCurrentVariantPrice();
    var p = calcPrices(price1, rec, discountPct);
    var p1El = fbt.querySelector('.cro-fbt__current-price');
    var origEl = fbt.querySelector('.cro-fbt__total-orig');
    var discEl = fbt.querySelector('.cro-fbt__total-disc');
    var savEl = fbt.querySelector('.cro-fbt__saving');
    if (p1El) p1El.textContent = fmt(price1);
    if (origEl) origEl.textContent = fmt(p.original);
    if (discEl) discEl.textContent = fmt(p.discounted);
    if (savEl) savEl.textContent = 'You save ' + fmt(p.saving);
  }

  function buildFBT(rule) {
    var infoEl = document.querySelector('[id^="ProductInfo-"]');
    if (!infoEl) return;
    if (infoEl.querySelector('.cro-fbt')) return;

    var currentImg = document.querySelector('.product__media-item img');
    // Get title from h1 only — avoid duplication
    var currentTitleEl = document.querySelector('.product__title h1');
    if (!currentTitleEl) currentTitleEl = document.querySelector('h1.product__title');
    var currentTitleText = currentTitleEl ? currentTitleEl.textContent.trim() : 'This Product';
    var currentImgSrc = currentImg ? currentImg.src : '';

    var price1 = getCurrentVariantPrice();
    var rec = rule.recommended[0];
    var p = calcPrices(price1, rec, rule.discountPct);

    var fbt = document.createElement('div');
    fbt.className = 'cro-fbt';
    fbt.innerHTML =
      '<div class="cro-fbt__badge">Frequently Bought Together — Save ' + rule.discountPct + '%</div>' +
      '<div class="cro-fbt__heading">Complete Your Carry</div>' +
      '<div class="cro-fbt__products">' +
        '<a class="cro-fbt__product" href="' + window.location.pathname + '">' +
          (currentImgSrc ? '<img src="' + currentImgSrc + '" alt="" loading="lazy">' : '') +
          '<span class="cro-fbt__product-title">' + currentTitleText + '</span>' +
          '<span class="cro-fbt__product-price cro-fbt__current-price">' + fmt(price1) + '</span>' +
        '</a>' +
        '<span class="cro-fbt__plus">+</span>' +
        '<a class="cro-fbt__product" href="' + rec.url + '">' +
          '<img src="' + rec.image + '" alt="' + rec.title + '" loading="lazy">' +
          '<span class="cro-fbt__product-title">' + rec.title + '</span>' +
          '<span class="cro-fbt__product-price">' + fmt(rec.price) + '</span>' +
        '</a>' +
      '</div>' +
      '<div class="cro-fbt__total">' +
        '<div class="cro-fbt__total-text">' +
          '<span style="text-decoration:line-through;opacity:0.45;font-size:1.2rem" class="cro-fbt__total-orig">' + fmt(p.original) + '</span> ' +
          '<strong class="cro-fbt__total-disc" style="font-size:1.7rem">' + fmt(p.discounted) + '</strong>' +
          '<span class="cro-fbt__saving" style="display:block;font-size:1.1rem;color:#2e7d32;font-weight:700;margin-top:2px">You save ' + fmt(p.saving) + '</span>' +
          '<span style="font-size:1.1rem;opacity:0.5;margin-top:4px;display:block">Use code <strong>' + rule.discountCode + '</strong> at checkout</span>' +
        '</div>' +
        '<button class="cro-fbt__btn" id="cro-fbt-btn">Add Both to Cart</button>' +
      '</div>';

    // Position: right after ATC form
    var atcForm = infoEl.querySelector('product-form, .product-form');
    if (atcForm) {
      atcForm.insertAdjacentElement('afterend', fbt);
    } else {
      infoEl.appendChild(fbt);
    }

    // ── Dynamic price sync ──
    // Method 1: Shopify variant:changed event (price comes in paisa)
    document.addEventListener('variant:changed', function(e) {
      var variant = e.detail && e.detail.variant;
      if (variant && variant.price) {
        var p1 = variant.price / 100;
        var prices = calcPrices(p1, rec, rule.discountPct);
        var p1El = fbt.querySelector('.cro-fbt__current-price');
        var origEl = fbt.querySelector('.cro-fbt__total-orig');
        var discEl = fbt.querySelector('.cro-fbt__total-disc');
        var savEl = fbt.querySelector('.cro-fbt__saving');
        if (p1El) p1El.textContent = fmt(p1);
        if (origEl) origEl.textContent = fmt(prices.original);
        if (discEl) discEl.textContent = fmt(prices.discounted);
        if (savEl) savEl.textContent = 'You save ' + fmt(prices.saving);
      }
    });

    // Method 2: radio/select change fallback
    document.querySelectorAll('fieldset input[type="radio"], select[name="id"]').forEach(function(input) {
      input.addEventListener('change', function() {
        setTimeout(function() { updateFBTPrices(fbt, rec, rule.discountPct); }, 200);
      });
    });

    // ── Add Both to Cart ──
    document.getElementById('cro-fbt-btn').addEventListener('click', function () {
      var btn = this;
      btn.textContent = 'Adding...';
      btn.disabled = true;
      var variantInput = document.querySelector('input[name="id"]:checked, input[name="id"], select[name="id"]');
      var variantId = variantInput ? variantInput.value : null;
      var items = [];
      if (variantId) items.push({ id: parseInt(variantId), quantity: 1 });
      fetch('/products/' + rec.handle + '.js')
        .then(function(r) { return r.json(); })
        .then(function(product) {
          items.push({ id: product.variants[0].id, quantity: 1 });
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
          });
        })
        .then(function() {
          return fetch('/discount/' + rule.discountCode);
        })
        .then(function() {
          btn.textContent = '✓ Added! Use code ' + rule.discountCode;
          btn.style.background = '#2e7d32';
          setTimeout(function() {
            btn.textContent = 'Add Both to Cart';
            btn.style.background = '';
            btn.disabled = false;
            var cartToggle = document.querySelector('[data-cart-icon-bubble], .cart-count-bubble, a[href="/cart"]');
            if (cartToggle) cartToggle.click();
          }, 3000);
        })
        .catch(function() {
          btn.textContent = 'Add Both to Cart';
          btn.disabled = false;
        });
    });
  }

  function init() {
    var handle = getCurrentHandle();
    if (!handle) return;
    var rule = FBT_RULES.find(function(r) { return r.productHandle === handle; });
    if (!rule) return;
    var tries = 0;
    var interval = setInterval(function() {
      var infoEl = document.querySelector('[id^="ProductInfo-"]');
      if (infoEl || tries > 20) {
        clearInterval(interval);
        if (infoEl) buildFBT(rule);
      }
      tries++;
    }, 300);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

})();
